import { PATENT_NUMBER_GLOBAL_REGEX } from '../../consts'

export const addPatentLinksToMarkdown = (
  markdown: string,
  searchAppUrl: string
) => {
  const result = markdown.replaceAll(
    PATENT_NUMBER_GLOBAL_REGEX,
    (match: string, _group: string) => {
      return `[${match}](${searchAppUrl}/patents/${match})`
    }
  )

  return result
}
